
// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import {
//     DndContext,
//     closestCenter,
//     KeyboardSensor,
//     PointerSensor,
//     useSensor,
//     useSensors,
//     DragEndEvent,
// } from "@dnd-kit/core";
// import {
//     arrayMove,
//     SortableContext,
//     sortableKeyboardCoordinates,
//     verticalListSortingStrategy,
// } from "@dnd-kit/sortable";
// import { useSortable } from "@dnd-kit/sortable";
// import { CSS } from "@dnd-kit/utilities";
// import config from '../../config';
// function SortableProjectRow({ project, index, categoryMap }) {
//     const {
//         attributes,
//         listeners,
//         setNodeRef,
//         transform,
//         transition,
//         isDragging,
//     } = useSortable({ id: project._id });

//     const style = {
//         transform: CSS.Transform.toString(transform),
//         transition,
//         opacity: isDragging ? 0.8 : 1,
//         background: isDragging ? '#f0f8ff' : 'transparent',
//     };

//     return (
//         <div
//             ref={setNodeRef}
//             style={style}
//             {...attributes}
//             className={`table-row ${isDragging ? 'dragging' : ''}`}
//         >
//             <div className="table-cell drag-handle" {...listeners}>
//                 <span className="drag-icon">Drag</span>
//             </div>

//             <div className="table-cell priority-number">{index + 1}</div>
//             <div className="table-cell"><p>{project.title}</p></div>
//             <div className="table-cell">
//                 <p>
//                     {Array.isArray(project.category) && project.category.length > 0
//                         ? project.category.map(c => categoryMap[c] || c).join(', ')
//                         : '-'}
//                 </p>
//             </div>
//             <div className="table-cell"><p>{project.ano}</p></div>
//             <div className="table-cell"><p>{project.cliente}</p></div>
//             <div className="table-cell text-right">
//                 <Link to={`/admin/project/${project._id}`} className="view_detail">
//                     View Details
//                 </Link>
//             </div>
//         </div>
//     );
// }
// function ProjectsListByCategory() {
//     const [projects, setProjects] = useState([]);
//     const [categoryMap, setCategoryMap] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const navigate = useNavigate();
//     const sensors = useSensors(
//         useSensor(PointerSensor, {
//             activationConstraint: {
//                 distance: 8,
//             },
//         }),
//         useSensor(KeyboardSensor, {
//             coordinateGetter: sortableKeyboardCoordinates,
//         })
//     );
//     const fetchProjects = async () => {
//         try {
//             const response = await axios.get(
//                 `${config.BASE_URL}/api/admin/get-featured-projects-by-priority`,
//                 { withCredentials: true }
//             );

//             if (response.data) {
//                 let sortedProjects = response.data.sort((a, b) => {
//                     const aPriority = typeof a.priorityNumber === 'number' ? a.priorityNumber : Infinity;
//                     const bPriority = typeof b.priorityNumber === 'number' ? b.priorityNumber : Infinity;
//                     return aPriority - bPriority;
//                 });
//                 const used = new Set();
//                 sortedProjects.forEach((p) => {
//                     if (typeof p.priorityNumber === 'number') used.add(p.priorityNumber);
//                 });

//                 let next = 1;
//                 const updates = [];
//                 sortedProjects = sortedProjects.map((p) => {
//                     if (typeof p.priorityNumber !== 'number') {
//                         while (used.has(next)) next++;
//                         updates.push({ _id: p._id, priorityNumber: next });
//                         used.add(next);
//                         next++;
//                         return { ...p, priorityNumber: next - 1 };
//                     }
//                     return p;
//                 });

//                 setProjects(sortedProjects);

//             }
//         } catch (err) {
//             setError('Failed to fetch featured projects');
//         } finally {
//             setLoading(false);
//         }
//     };

//     const fetchCategories = async () => {
//         try {
//             const res = await axios.get(`${config.BASE_URL}/api/admin/categories/list`, {
//                 withCredentials: true,
//             });
//             const list = res?.data?.data || [];
//             const map = {};
//             list.forEach((c) => {
//                 if (c?._id) map[c._id] = c?.name;
//             });
//             setCategoryMap(map);
//         } catch (e) {
//             // Silent fail
//         }
//     };
//     const handleDragEnd = async (event) => {
//         const { active, over } = event;
//         if (!over || active.id === over.id) return;

//         const oldIndex = projects.findIndex(p => p._id === active.id);
//         const newIndex = projects.findIndex(p => p._id === over.id);

//         const newOrder = arrayMove(projects, oldIndex, newIndex);
//         const payload = newOrder.map((p, idx) => ({
//             _id: p._id,
//             priorityNumber: idx + 1,
//         }));

//         setProjects(newOrder);

//         try {
//             await axios.post(
//                 `${config.BASE_URL}/api/admin/update-project-priorities`,
//                 { projects: payload },
//                 { withCredentials: true }
//             );
//         } catch (e) {
//             fetchProjects();
//         }
//     };
//     useEffect(() => {
//         fetchProjects();
//         fetchCategories();
//     }, []);
//     return (
//         <>
//             <div className="dashboard">
//                 <div className="container">
//                     <h1 className="dash_title">Featured Projects</h1>
//                     <div className="main-section">
//                         <div className="projects">
//                             <div className="projects-inner">
//                                 <header className="projects-header">
//                                     <div className="title">
//                                         Total
//                                         <div className="count"> {projects.length} Featured Projects</div>
//                                     </div>
//                                     <div className="project_search">
//                                         <form action="">
//                                             <input
//                                                 type="text"
//                                                 name="search"
//                                                 placeholder="Search featured projects"
//                                             />
//                                             <button type="submit" className="btn">Search</button>
//                                         </form>
//                                     </div>
//                                     <div className="add_project">
//                                         <Link to="/admin/add-project">Add Project</Link>
//                                     </div>
//                                 </header>

//                                 <DndContext
//                                     sensors={sensors}
//                                     collisionDetection={closestCenter}
//                                     onDragEnd={handleDragEnd}
//                                 >
//                                     <SortableContext
//                                         items={projects.map(p => p._id)}
//                                         strategy={verticalListSortingStrategy}
//                                     >
//                                         <div className="projects-table">
//                                             <div className="table-header">
//                                                 <div className="header-cell drag-handle">Drag</div>
//                                                 <div className="header-cell">Priority</div>
//                                                 <div className="header-cell">Project Title</div>
//                                                 <div className="header-cell">Categories</div>
//                                                 <div className="header-cell">Ano</div>
//                                                 <div className="header-cell">Cliente</div>
//                                                 <div className="header-cell text-right">Actions</div>
//                                             </div>

//                                             <div className="table-body">
//                                                 {loading ? (
//                                                     <div className="table-row">
//                                                         <div className="table-cell">Loading...</div>
//                                                     </div>
//                                                 ) : error ? (
//                                                     <div className="table-row">
//                                                         <div className="table-cell">{error}</div>
//                                                     </div>
//                                                 ) : projects.length === 0 ? (
//                                                     <div className="table-row">
//                                                         <div className="table-cell">No featured projects</div>
//                                                     </div>
//                                                 ) : (
//                                                     projects.map((project, index) => (
//                                                         <SortableProjectRow
//                                                             key={project._id}
//                                                             project={project}
//                                                             index={index}
//                                                             categoryMap={categoryMap}
//                                                         />
//                                                     ))
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </SortableContext>
//                                 </DndContext>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default ProjectsListByCategory;

























import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
    DndContext,
    closestCenter,
    KeyboardSensor,
    PointerSensor,
    useSensor,
    useSensors,
} from "@dnd-kit/core";
import {
    arrayMove,
    SortableContext,
    sortableKeyboardCoordinates,
    verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import config from "../../config";
import aptContent from "../../JSONData/allProjectsTabs.json"; // Import for labels

// SortableProjectRow component for drag-and-drop
function SortableProjectRow({ project, index, categoryMap }) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id: project._id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.8 : 1,
        background: isDragging ? "#f0f8ff" : "transparent",
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            {...attributes}
            className={`table-row ${isDragging ? "dragging" : ""}`}
        >
            <div className="table-cell drag-handle" {...listeners}>
                <span className="drag-icon">⋮⋮</span>
            </div>
            <div className="table-cell priority-number">{index + 1}</div>
            <div className="table-cell">
                <p>{project.title}</p>
            </div>
            <div className="table-cell">
                <p>
                    {Array.isArray(project.category) && project.category.length > 0
                        ? project.category.map((c) => categoryMap[c] || c).join(", ")
                        : "-"}
                </p>
            </div>
            <div className="table-cell">
                <p>{project.ano}</p>
            </div>
            <div className="table-cell">
                <p>{project.cliente}</p>
            </div>
            <div className="table-cell text-right">
                <Link to={`/admin/project/${project._id}`} className="view_detail">
                    View Details
                </Link>
            </div>
        </div>
    );
}

function ProjectsListByCategory() {
    const [projects, setProjects] = useState([]);
    const [categoryMap, setCategoryMap] = useState({});
    const [categoryTabs, setCategoryTabs] = useState([]);
    const [activeTab, setActiveTab] = useState("ALL");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const navigate = useNavigate();
    const { lang } = useParams(); // Support language parameter
    const labels = aptContent && aptContent[lang] ? aptContent[lang] : aptContent?.en;

    // Set up sensors for drag-and-drop
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        }),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    // Fetch projects and categories
    const fetchData = async () => {
        try {
            setLoading(true);
            const params = {
                sort: "position", // Sort by priorityNumber
            };
            if (lang) params.lang = lang;
            if (activeTab !== "ALL") params.category = activeTab;

            const response = await axios.get(`${config.BASE_URL}/api/admin/projects-cat-ord`, {
                params,
                withCredentials: true,
            });

            if (response.data.success) {
                let sortedProjects = response.data.data.projects || [];
                // Sort by priorityNumber (ascending), nulls at the end
                sortedProjects = sortedProjects.sort((a, b) => {
                    const aPriority = typeof a.priorityNumber === "number" ? a.priorityNumber : Infinity;
                    const bPriority = typeof b.priorityNumber === "number" ? b.priorityNumber : Infinity;
                    return aPriority - bPriority;
                });

                // Auto-fill missing priority numbers
                const used = new Set();
                sortedProjects.forEach((p) => {
                    if (typeof p.priorityNumber === "number") used.add(p.priorityNumber);
                });
                let next = 1;
                const updates = [];
                sortedProjects = sortedProjects.map((p) => {
                    if (typeof p.priorityNumber !== "number") {
                        while (used.has(next)) next++;
                        updates.push({ _id: p._id, priorityNumber: next });
                        used.add(next);
                        next++;
                        return { ...p, priorityNumber: next - 1 };
                    }
                    return p;
                });

                setProjects(sortedProjects);

                // Set categories only on initial load or when ALL is active
                if (activeTab === "ALL" && response.data.data.categories) {
                    const categories = response.data.data.categories.map((c) => ({
                        id: c._id,
                        name: c.name,
                    }));
                    setCategoryTabs(categories);

                    // Create category map for display
                    const map = {};
                    categories.forEach((c) => {
                        if (c?.id) map[c.id] = c?.name;
                    });
                    setCategoryMap(map);
                }
            } else {
                setError("Failed to fetch data");
                setProjects([]);
            }
        } catch (err) {
            setError("Failed to fetch featured projects");
            setProjects([]);
        } finally {
            setLoading(false);
        }
    };

    // Handle drag-and-drop
    // const handleDragEnd = async (event) => {
    //     const { active, over } = event;
    //     if (!over || active.id === over.id) return;

    //     const oldIndex = projects.findIndex((p) => p._id === active.id);
    //     const newIndex = projects.findIndex((p) => p._id === over.id);

    //     const newOrder = arrayMove(projects, oldIndex, newIndex);
    //     const payload = newOrder.map((p, idx) => ({
    //         _id: p._id,
    //         priorityNumber: idx + 1,
    //     }));

    //     setProjects(newOrder);

    //     try {
    //         await axios.post(
    //             `${config.BASE_URL}/api/admin/update-project-category`,
    //             { projects: payload },
    //             { withCredentials: true }
    //         );
    //     } catch (e) {
    //         // Revert to server state on error
    //         fetchData();
    //     }
    // };
    const handleDragEnd = async (event) => {
        const { active, over } = event;
        if (!over || active.id === over.id) return;

        const oldIndex = projects.findIndex((p) => p._id === active.id);
        const newIndex = projects.findIndex((p) => p._id === over.id);

        const newOrder = arrayMove(projects, oldIndex, newIndex);
        const payload = {
            category: activeTab, // Send the current active tab (category ID or "ALL")
            projects: newOrder.map((p, idx) => ({
                _id: p._id,
                priorityNumber: idx + 1,
            })),
        };

        setProjects(newOrder);

        try {
            await axios.post(
                `${config.BASE_URL}/api/admin/update-project-category`,
                payload,
                { withCredentials: true }
            );
        } catch (e) {
            // Revert to server state on error
            fetchData();
        }
    };
    // Handle tab change
    const handleTabs = (tab) => {
        setActiveTab(tab);
    };

    // Fetch data when activeTab or lang changes
    useEffect(() => {
        fetchData();
    }, [activeTab, lang]);

    return (
        <div className="dashboard">
            <div className="container">
                <h1 className="dash_title">{labels.featuredProjects || "Category Projects"}</h1>
                <div className="main-section">
                    <div className="projects">
                        <div className="projects-inner">
                            <header className="projects-header">
                                <div className="title">
                                    {labels.total || "Total"}
                                    <div className="count">
                                        {projects.length} {labels.featuredProjects || "Category Projects"}
                                    </div>
                                </div>
                                <div className="project_search">
                                    <form action="">
                                        <input
                                            type="text"
                                            name="search"
                                            placeholder={labels.searchPlaceholder || "Search projects"}
                                        />
                                        <button type="submit" className="btn">
                                            {labels.search || "Search"}
                                        </button>
                                    </form>
                                </div>
                                <div className="add_project">
                                    <Link to="/admin/add-project">{labels.addProject || "Add Project"}</Link>
                                </div>
                            </header>

                            {/* Category Tabs */}
                            <div className="property-filters">
                                <h3 className="h5 fw-300">{labels.byCategory || "By Category"}</h3>
                                <div className="tab-buttons d-flex align-end gap-30">
                                    <Link
                                        key="ALL"
                                        className={`button tab-button ${activeTab === "ALL" ? "active" : ""}`}
                                        onClick={() => handleTabs("ALL")}
                                    >
                                        {labels.all || "ALL"}
                                    </Link>
                                    {categoryTabs.map((cat) => (
                                        <Link
                                            key={cat.id}
                                            className={`button tab-button ${activeTab === cat.id ? "active" : ""}`}
                                            onClick={() => handleTabs(cat.id)}
                                        >
                                            {cat.name.toUpperCase()}
                                        </Link>
                                    ))}
                                </div>
                            </div>

                            {/* Projects Table */}
                            <DndContext sensors={activeTab === "ALL" ? [] : sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
                                <SortableContext
                                    items={projects.map((p) => p._id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <div className="projects-table">
                                        <div className="table-header">

                                            <div className={`header-cell ${activeTab === "ALL" ? '' : 'drag-handle'}`}>
                                                {labels.drag || "Drag"}
                                            </div>
                                            <div className="header-cell">{labels.priority || "Priority"}</div>
                                            <div className="header-cell">{labels.projectTitle || "Project Title"}</div>
                                            <div className="header-cell">{labels.categories || "Categories"}</div>
                                            <div className="header-cell">{labels.ano || "Ano"}</div>
                                            <div className="header-cell">{labels.cliente || "Cliente"}</div>
                                            <div className="header-cell text-right">
                                                {labels.actions || "Actions"}
                                            </div>
                                        </div>
                                        <div className="table-body">
                                            {loading ? (
                                                <div className="table-row">
                                                    <div className="table-cell">
                                                        {labels.loading || "Loading..."}
                                                    </div>
                                                </div>
                                            ) : error ? (
                                                <div className="table-row">
                                                    <div className="table-cell">{error}</div>
                                                </div>
                                            ) : projects.length === 0 ? (
                                                <div className="table-row">
                                                    <div className="table-cell">
                                                        {labels.noProjects || "No featured projects"}
                                                    </div>
                                                </div>
                                            ) : (
                                                projects.map((project, index) => (
                                                    <SortableProjectRow
                                                        key={project._id}
                                                        project={project}
                                                        index={index}
                                                        categoryMap={categoryMap}
                                                    />
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </SortableContext>
                            </DndContext>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ProjectsListByCategory;
